'use strict';

var _util = require('./util');

var _cookies = require('./util/cookies');

var _accordion = require('./ui/accordion');

var _choices = require('choices.js');

var _choices2 = _interopRequireDefault(_choices);

var _form = require('./form');

var _modal = require('./ui/modal');

var _slider = require('./slider');

var _slider2 = _interopRequireDefault(_slider);

var _counter = require('./ui/counter');

var _counter2 = _interopRequireDefault(_counter);

var _video = require('./ui/video');

var _video2 = _interopRequireDefault(_video);

var _scrollAnim = require('./ui/scroll-anim');

var _scrollAnim2 = _interopRequireDefault(_scrollAnim);

var _nav = require('./ui/nav');

var _nav2 = _interopRequireDefault(_nav);

var _developmentSearch = require('./ui/development-search');

var _developmentSearch2 = _interopRequireDefault(_developmentSearch);

var _map = require('./ui/map');

var _map2 = _interopRequireDefault(_map);

var _postcodeLookup = require('./form/postcode-lookup');

var _postcodeLookup2 = _interopRequireDefault(_postcodeLookup);

var _contactPage = require('./ui/contact-page');

var _contactPage2 = _interopRequireDefault(_contactPage);

var _postcodeLookupContent = require('./form/postcode-lookup-content');

var _postcodeLookupContent2 = _interopRequireDefault(_postcodeLookupContent);

var _smoothscroll = require('./ui/smoothscroll');

var _smoothscroll2 = _interopRequireDefault(_smoothscroll);

var _cookie = require('./ui/cookie');

var _tabs = require('./ui/tabs');

var _dialogs = require('./ui/dialogs');

var _Observable = require('rxjs/Observable');

require('rxjs/add/observable/fromEvent');

require('rxjs/add/operator/filter');

require('lightbox2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
    (0, _util.polyfill)();
    (0, _accordion.Accordions)();
    inputSelects();
    (0, _form.inputGroup)();
    setupForms();
    (0, _modal.setupModals)();
    setupSlider();
    (0, _counter2.default)();
    (0, _video2.default)();
    (0, _scrollAnim2.default)();
    (0, _nav2.default)();
    (0, _developmentSearch2.default)();
    (0, _map2.default)();
    (0, _postcodeLookup2.default)();
    (0, _contactPage2.default)();
    (0, _postcodeLookupContent2.default)();
    (0, _smoothscroll2.default)();
    // setupChatbot()
    (0, _cookie.CookieBar)();
    reciteMeInit();
    iframeWrap();
    setupPopOut();
    // chatbotScroll()
    formAlert();
    (0, _tabs.CreateTabs)();
    (0, _dialogs.Dialogs)();
    feedbackButton();
    autocomplete();
    if (window.jumpID) {
        window.location.hash = 'fmgmt-register';
    }
}

function formAlert() {
    var el = document.querySelector('.js-form-alert');

    if (!el) {
        return;
    }

    el.showModal();

    el.addEventListener('click', function (evt) {
        if (evt.target.classList.contains('js-modal-close') || evt.offsetX < 0 || evt.offsetX > evt.target.offsetWidth || evt.offsetY < 0 || evt.offsetY > evt.target.offsetHeight) {
            evt.preventDefault();
            el.close();
            location.reload();
        }
    });
}

function autocomplete() {

    function displayMatches() {
        var _this = this;

        console.log("Keyup");

        var endpoint = '/ajax/search?q=' + this.value;

        if (this.value.length >= 3) {

            fetch(endpoint).then(function (response) {
                return response.json();
            }).then(function (data) {
                return data.data;
            }).then(function (results) {
                if (typeof results != 'undefined') {

                    if (results.length > 0) {
                        suggestions.classList.add('active');
                    } else {
                        suggestions.classList.remove('active');
                    }

                    var html = results.map(function (result) {

                        var regex = new RegExp(_this.value, 'gi');
                        var label = result.label.replace(regex, '<strong>' + _this.value + '</strong>');
                        var url = result.url;

                        return '\n                                <li>\n                                    <a href="' + url + '" class="result">' + label + '</a>\n                                </li>\n                            ';
                    }).join('');
                    suggestions.innerHTML = html;
                }
            });
        }
    }

    var searchInput = document.querySelector('.ajax-search-input');
    var suggestions = document.querySelector('.autocomplete');

    if (searchInput) {
        searchInput.addEventListener('change', displayMatches);
        searchInput.addEventListener('keyup', displayMatches);
    }
    document.addEventListener('click', function (e) {
        var autocomplete = document.querySelector('.autocomplete');
        if (autocomplete) {
            if (autocomplete.contains(e.target)) {} else {
                autocomplete.classList.remove('active');
            }
        }
    });
}

function feedbackButton() {

    var el = document.querySelector('.js-feedback-button');
    var no = document.querySelector('.js-feedback-form-button');
    var form = document.querySelector('.c-feedback-message');

    if (document.querySelectorAll('.js-feedback-form-button').length) {
        no.addEventListener('click', function (evt) {
            console.log("clicked no button");
            evt.preventDefault();
            el.classList.remove('active');
            no.classList.add('active');
            form.classList.remove('hidden');
        });
    }

    if (!el) {
        return;
    }

    el.addEventListener('click', function (evt) {

        evt.preventDefault();

        no.classList.remove('active');
        form.classList.add('hidden');

        if (el.classList.contains('active')) {
            console.log('Do nothing');
        } else {
            // Send AJAX feedback request
            el.classList.add('active');

            var url = '/feedback';
            var article_id = el.dataset.articleid;
            var csrfToken = el.dataset.csrf;

            var headers = {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            };

            fetch(url, {
                'method': 'POST',
                'body': JSON.stringify({
                    'article_id': article_id,
                    'invalidate': true
                }),
                'headers': headers
            }).then(function (response) {
                return response.json();
            }).then(function (response) {
                console.log(response);
                el.classList.add('active');
            }).catch(function (err) {
                return console.log(err);
            });
        }
    });
}

function chatbotScroll() {
    var chatbotButton = void 0;
    var footerBarEl = document.querySelector('.c-footer__bar');
    var currentScroll = void 0;
    var percent = void 0;
    var isAnimating = false;

    _Observable.Observable.fromEvent(window, 'scroll').subscribe(updateChatbotPosition);

    function updateChatbotPosition() {
        currentScroll = window.scrollY;

        if (window.matchMedia('(min-width: 768px').matches) {
            return;
        }

        if (currentScroll >= document.body.scrollHeight - window.innerHeight - footerBarEl.offsetHeight) {
            if (!chatbotButton) {
                chatbotButton = document.querySelector('.cxco-c-action');
            }

            if (!chatbotButton.classList.contains('unfix')) {
                chatbotButton.classList.add('unfix');
                chatbotButton.style.opacity = 0;
            }

            if (chatbotButton.classList.contains('unfix')) {
                if (isAnimating) {
                    return;
                }

                isAnimating = true;
                requestAnimationFrame(function () {
                    percent = (currentScroll - (document.body.scrollHeight - window.innerHeight - footerBarEl.offsetHeight)) / footerBarEl.offsetHeight;
                    chatbotButton.style.transform = 'translateY(-' + footerBarEl.offsetHeight * percent + 'px)';
                    chatbotButton.style.opacity = Math.ceil(1 - percent);
                    isAnimating = false;
                });
            }
        } else if (chatbotButton && chatbotButton.classList.contains('unfix')) {
            chatbotButton.classList.remove('unfix');
            chatbotButton.style.transform = '';
            chatbotButton.style.opacity = 1;
        }
    }
}

function setupPopOut() {
    var cookieName = 'popOutSeen';
    if (window.rememberPopoutName) {
        cookieName += window.rememberPopoutName;
    }
    if (!(0, _cookies.getCookie)(cookieName)) {
        if (window.popoutOnExit) {
            var counter = 0;
            var mouseY = void 0;
            document.addEventListener('mousemove', function (e) {
                mouseY = e.clientY;
            });
            document.addEventListener('mouseleave', function () {
                if (mouseY < 100) {
                    if (counter < 1) {
                        _modal.modalController.openModal('PopOut');
                        (0, _cookies.setCookie)(cookieName, true);
                    }
                    counter++;
                }
            });
        } else if (window.timedPopout > 0) {
            var delay = window.timedPopout * 1000;
            setTimeout(function () {
                requestAnimationFrame(function () {
                    _modal.modalController.openModal('PopOut');
                    (0, _cookies.setCookie)(cookieName, true);
                });
            }, delay);
        }
    }
}

function setupSlider() {
    var arrows = {
        prev: '<button class="o-slider__arrow o-arrow-btn o-arrow-btn--left">\n                    <div class="o-arrow-btn__wrap">\n                        <span>\u2190</span>\n                    </div>\n                </button>',
        next: '<button class="o-slider__arrow o-arrow-btn o-arrow-btn--right">\n                    <div class="o-arrow-btn__wrap">\n                        <span>\u2192</span>\n                    </div>\n                </button>'
    };

    var sliders = document.querySelectorAll('.js-slider');
    sliders = Array.from(sliders);
    sliders.forEach(function (el) {
        (0, _slider2.default)(el, {
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [{ breakpoint: 768, options: { slidesToShow: 3, autoplay: false } }]
        }, {}, arrows);
    });

    var sliderHalves = document.querySelectorAll('.js-slider-halves');
    sliderHalves = Array.from(sliderHalves);
    sliderHalves.forEach(function (el) {
        (0, _slider2.default)(el, {
            slidesToShow: 1,
            autoplay: false,
            responsive: [{ breakpoint: 768, options: { slidesToShow: 2 } }]
        }, {}, arrows);
    });
}

function inputSelects() {
    var selects = document.querySelectorAll('.js-select');
    Array.prototype.forEach.call(selects, function (el) {
        return new _choices2.default(el, {
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: '',
            callbackOnCreateTemplates: function callbackOnCreateTemplates(template) {
                var classNames = this.config.classNames;
                return {
                    containerInner: function containerInner() {
                        return template('\n                    <div class="' + classNames.containerInner + '">\n                        <div class="choices__btn">\n                            <svg><use xlink:href="/images/svgicons.svg#arrow-small-down"></use></svg>\n                        </div>\n                    </div>\n                ');
                    }
                };
            }
        });
    });

    var selectsPlain = document.querySelectorAll('.js-select-plain');
    Array.prototype.forEach.call(selectsPlain, function (el) {
        return new _choices2.default(el, {
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: '',
            classNames: {
                containerOuter: 'choices choices--plain'
            },
            callbackOnCreateTemplates: function callbackOnCreateTemplates(template) {
                var classNames = this.config.classNames;
                return {
                    containerInner: function containerInner() {
                        return template('\n                    <div class="' + classNames.containerInner + '">\n                        <div class="choices__btn">\n                            <svg><use xlink:href="/images/svgicons.svg#arrow-small-down"></use></svg>\n                        </div>\n                    </div>\n                ');
                    }
                };
            }
        });
    });

    var selectsInline = document.querySelectorAll('.js-select-inline');
    Array.prototype.forEach.call(selectsInline, function (el) {
        return new _choices2.default(el, {
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: '',
            classNames: {
                containerOuter: 'choices choices--inline'
            },
            callbackOnCreateTemplates: function callbackOnCreateTemplates(template) {
                var classNames = this.config.classNames;
                return {
                    containerInner: function containerInner() {
                        return template('\n                    <div class="' + classNames.containerInner + '">\n                        <div class="choices__btn">\n                            <svg><use xlink:href="/images/svgicons.svg#arrow-small-down"></use></svg>\n                        </div>\n                    </div>\n                ');
                    }
                };
            }
        });
    });

    var selectsRents = document.querySelectorAll('.js-select-rents');
    Array.prototype.forEach.call(selectsRents, function (el) {
        el.addEventListener('change', function (el) {
            window.location = el.target.value;
        });

        return new _choices2.default(el, {
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: '',
            classNames: {
                containerOuter: 'choices choices--white'
            },
            callbackOnCreateTemplates: function callbackOnCreateTemplates(template) {
                var classNames = this.config.classNames;
                return {
                    containerInner: function containerInner() {
                        return template('\n                    <div class="' + classNames.containerInner + '">\n                        <div class="choices__btn">\n                            <svg><use xlink:href="/images/svgicons.svg#arrow-small-down"></use></svg>\n                        </div>\n                    </div>\n                ');
                    }
                };
            }
        });
    });
}

function setupForms() {
    (0, _form.Controller)('.js-form');
}

function searchProperties(e) {
    e.preventDefault();
    var url = window.location.href;
    var minBeds = document.getElementById('minBeds');
    var maxBeds = document.getElementById('maxBeds');
    var keywords = document.getElementById('keywords').value;

    minBeds = parseInt(minBeds.options[minBeds.selectedIndex].value);
    maxBeds = parseInt(maxBeds.options[maxBeds.selectedIndex].value);

    if (isInteger(minBeds) || isInteger(maxBeds) || keywords.length) {
        if (isInteger(minBeds)) {
            url = setParam(url, 'min', minBeds);
        } else {
            url = removeParam(url, 'min');
        }
        if (isInteger(maxBeds)) {
            url = setParam(url, 'max', maxBeds);
        } else {
            url = removeParam(url, 'max');
        }
        if (keywords.length) {
            url = setParam(url, 'keywords', keywords);
        } else {
            url = removeParam(url, 'keywords');
        }
    }
    window.location.href = url;
}

function isInteger(x) {
    return (x ^ 0) === x;
}

window.searchProperties = searchProperties;

function applyFiltersAndLoadPage() {
    var uri = window.location.href;
    var locationNodes = document.querySelectorAll('input[name=location]:checked');
    var propertyNodes = document.querySelectorAll('input[name=property]:checked');
    var locations = [];
    var properties = [];

    Array.prototype.forEach.call(locationNodes, function (location) {
        locations.push(location.value);
    });

    Array.prototype.forEach.call(propertyNodes, function (property) {
        properties.push(property.value);
    });

    if (locations.length) {
        uri = setParam(uri, 'location', locations.join('-'));
    } else {
        uri = removeParam(uri, 'location');
    }
    if (properties.length) {
        uri = setParam(uri, 'property', properties.join('-'));
    } else {
        uri = removeParam(uri, 'property');
    }
    window.location.href = uri;
}

window.applyFiltersAndLoadPage = applyFiltersAndLoadPage;

function setParam(uri, key, val) {
    return uri.replace(RegExp('([?&]' + key + '(?=[=&#]|$)[^#&]*|(?=#|$))'), '&' + key + '=' + encodeURIComponent(val)).replace(/^([^?&]+)&/, '$1?');
}

window.setParam = setParam;

function removeParam(uri, paramName) {
    var uriParts = uri.split('?');
    if (uriParts.length >= 2) {
        var prefix = encodeURIComponent(paramName) + '=';
        var params = uriParts[1].split(/[&;]/g);
        for (var i = params.length; i-- > 0;) {
            if (params[i].lastIndexOf(prefix, 0) !== -1) {
                params.splice(i, 1);
            }
        }
        uri = uriParts[0] + (params.length > 0 ? '?' + params.join('&') : '');
    }
    return uri;
}

window.removeParam = removeParam;

function setupChatbot() {
    window.cxcoConfig = {
        /* project/database configuration */
        project: {
            publicApiKey: '78e088d4-f588-4cfe-bd58-cdacfcdf32d5',
            culture: 'en',
            customerKey: 'VIVIDHOMES',
            key: 'VIVIDHOMES'
        },
        engineUrl: window.chatbotEngine,
        dci: {
            layout: {
                initialState: window.chatbotStartOpen ? 'opened' : 'minimized',
                showAvatar: true
            }
        }
    };
    window.cxco = window.cxco || [];(function (d, t) {
        var g = d.createElement(t),
            s = d.getElementsByTagName(t)[0];
        g.src = '//projects.elitechnology.com/jsprojects/cxco/dci/3/init.js?v=' + +new Date();
        g.async = true;
        s.parentNode.insertBefore(g, s);
    })(document, 'script');

    cxco.push(['on', 'chatbot.ready', function () {
        var chat = document.querySelector('.cxco-o-chat');
        var resetBtn = document.createElement('button');

        resetBtn.classList.add('cxco-c-reset-btn');
        resetBtn.classList.add('js-reset-chat');
        resetBtn.innerHTML = 'Reset chat';
        chat.appendChild(resetBtn);

        _Observable.Observable.fromEvent(document, 'click').filter(function (evt) {
            return evt.target.classList.contains('js-reset-chat');
        }).subscribe(function (evt) {
            evt.preventDefault();
            resetChatbot();
        });
    }]);
}

function resetChatbot() {
    cxco.push(['archive']);
    cxco.push(['sendEvent', 'onload']);
}

function reciteMeInit() {
    _Observable.Observable.fromEvent(document, 'click').filter(function (evt) {
        return evt.target.classList.contains('js-reciteme');
    }).subscribe(function (evt) {
        evt.preventDefault();
        window.loadService();
    });
}

function iframeWrap() {
    var iframes = document.querySelectorAll('iframe[src*=issuu]');
    iframes = Array.from(iframes);
    iframes.forEach(function (el) {
        if (el.parentNode.classList.contains('o-iframe-wrap')) {
            return;
        }

        var wrapper = document.createElement('div');
        wrapper.classList.add('o-iframe-wrap');
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    });
}

if (document.readyState !== 'loading') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init);
}

if (window.showChatbot) {
    var startChat = function startChat() {
        if (isLCWReady) {
            Microsoft.Omnichannel.LiveChatWidget.SDK.startChat({ inNewWindow: false });
            hideChatBtn();
        } else {
            console.log('LCW not ready yet.');
        }
    };

    var showChatBtn = function showChatBtn() {
        document.querySelector('#ChatBtn').style.display = 'block';
    };

    var hideChatBtn = function hideChatBtn() {
        document.querySelector('#ChatBtn').style.display = 'none';
    };

    // Conditional show/hide


    var isLCWReady = false;
    var chatBtn = document.getElementById('ChatBtn');

    chatBtn.addEventListener('click', startChat);

    window.addEventListener('lcw:startChat', hideChatBtn);
    window.addEventListener('lcw:chatRetrieved', hideChatBtn);
    window.addEventListener('lcw:onClose', showChatBtn);
    window.addEventListener('lcw:onMinimize', showChatBtn);

    window.addEventListener('lcw:ready', function () {
        isLCWReady = true;
        showChatBtn();
    });
    // Conditional show/hide
    window.addEventListener("lcw:onClose", showChatBtn);
    window.addEventListener("lcw:onMinimize", function () {
        setItemInLocalStorage("ChatMinimized", true);
        showChatBtn();
    });

    window.addEventListener("lcw:onMaximize", function () {
        setItemInLocalStorage("ChatMinimized", false);
        hideChatBtn();
    });

    window.addEventListener("lcw:startChat", hideChatBtn);
    window.addEventListener("lcw:chatRetrieved", function () {
        if (!getItemFromLocalStorage("ChatMinimized")) {
            hideChatBtn();
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/index.js
// module id = ./resources/assets/js/src/index.js
// module chunks = 0